import ReCAPTCHA from 'react-google-recaptcha';

type RecaptchaV2Types = {
  onChange: (token: string | null) => void;
};

export const RecaptchaV2 = ({ onChange }: RecaptchaV2Types) => {
  return (
    <ReCAPTCHA
      sitekey="6LfDNp0mAAAAALUakU6uZbTSSLpCZ0UZdiT7uo3g"
      onChange={onChange}
    />
  );
};
